import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ship1',
  templateUrl: './ship1.component.html',
  styleUrls: ['./ship1.component.css']
})
export class Ship1Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
